import React, { useRef, useState } from 'react';
import clsx from 'clsx';
import style from './style.module.scss';
import { timeUtils } from 'utils/timeUtil';
import Calendar from 'components/calendar';
import CalendarDrawer from 'components/calendar/drawer';
import SoccerSearch from './search';
import SoundPromptSettings from 'components/soundPromptSettings';

const SoccerContainer = ({
  children,
  onChangePage,
  count,
  selectedTab,
  setSelectedTab,
  getSoccerToday,
  todayFinalCount,
  getTodayFinalSoccer,
  clearSearchValue,
  getTodayFinalCount,
  getFavoriteTodayGameIds,
  getSoccerInterestGames,
  currentDate,
  today,
  setCurrentDate
}) => {
  const calendarOpenButtonRef = useRef();
  const [isOpenWebCalendar, setIsOpenWebCalendar] = useState(false);

  const onClickPrev = () => {
    const prev = timeUtils.datePrevOrNext(currentDate, 'prev');

    setCurrentDate(prev);
    clearSearchValue();

    if (today === prev) {
      getSoccerToday();
      getTodayFinalCount();
    } else {
      onChangePage(prev);
    }

    setSelectedTab('ALL');
  };

  const onClickNext = () => {
    const next = timeUtils.datePrevOrNext(currentDate, 'next');

    setCurrentDate(next);
    clearSearchValue();

    if (today === next) {
      getSoccerToday();
      getTodayFinalCount();
    } else {
      onChangePage(next);
    }

    setSelectedTab('ALL');
  };

  const onClickToday = () => {
    setCurrentDate(today);
    clearSearchValue();
    getSoccerToday();
    getTodayFinalCount();
    setSelectedTab('ALL');
  };

  const onClickRefresh = () => {
    if (currentDate === today) {
      getSoccerToday();
      getTodayFinalCount();
    } else {
      onChangePage(currentDate);
    }
  };

  const onClickTab = (type) => {
    let label = '전체';

    if (type === 'ALL') {
      label = '전체';
    } else if (type === 'FAVORITE') {
      label = '관심경기';
      getSoccerInterestGames(getFavoriteTodayGameIds);
    } else if (type === 'FINAL') {
      label = '종료경기';
      getTodayFinalSoccer(today);
    }

    clearSearchValue();
    setSelectedTab(type);
  };

  const onClickCalendarButton = () => {
    setIsOpenWebCalendar(!isOpenWebCalendar);
  };

  const onChangeCalendarPage = (date) => {
    clearSearchValue();

    if (date === today) {
      getSoccerToday();
      getTodayFinalCount();
    } else {
      onChangePage(date);
    }
  };

  return (
    <>
      <div className={style.option_wrap}>
        <div className={style.calendar_area}>
          <button
            className={clsx(style.btn_ic, style.btn_prev)}
            onClick={onClickPrev}
          >
            이전
          </button>
          <span className={style.date}>{currentDate.split('-').join('.')}</span>
          <button
            className={clsx(style.btn_ic, style.btn_next)}
            onClick={onClickNext}
          >
            다음
          </button>
          <button
            ref={calendarOpenButtonRef}
            className={clsx(style.btn_bx, style.btn_calendar)}
            onClick={onClickCalendarButton}
          >
            달력
          </button>
          <button
            className={clsx(style.btn_bx, style.btn_today)}
            onClick={onClickToday}
          >
            오늘
          </button>
        </div>
        <div className={style.option_btn_area}>
          <SoundPromptSettings sportsType="soccer" />
          <button
            className={clsx(style.btn, style.btn_refresh)}
            onClick={onClickRefresh}
          >
            새로고침
          </button>
        </div>
        <div className={style.category_area}>
          <ul className={style.tab}>
            <li className={clsx(selectedTab === 'ALL' && style.selected)}>
              <button onClick={() => onClickTab('ALL')}>
                전체({count.all})
              </button>
            </li>
            <li className={clsx(selectedTab === 'FAVORITE' && style.selected)}>
              <button onClick={() => onClickTab('FAVORITE')}>
                관심경기({count.favorite})
              </button>
            </li>
            {currentDate === today && (
              <li className={clsx(selectedTab === 'FINAL' && style.selected)}>
                <button onClick={() => onClickTab('FINAL')}>
                  종료경기({todayFinalCount})
                </button>
              </li>
            )}
          </ul>
          <div className={style.search}>
            <SoccerSearch currentDate={currentDate} />
          </div>
        </div>
        <CalendarDrawer
          transitionClass="web-calendar-transition"
          isOpen={isOpenWebCalendar}
          closeDrawer={() => setIsOpenWebCalendar(false)}
        >
          <Calendar
            onClickToday={onClickToday}
            currentDate={currentDate}
            onChangePage={onChangeCalendarPage}
            setCurrentDate={setCurrentDate}
            sportsType={'soccer'}
            closeDrawer={() => setIsOpenWebCalendar(false)}
            calendarOpenButtonRef={calendarOpenButtonRef}
          />
        </CalendarDrawer>
      </div>
      {children}
    </>
  );
};

export default SoccerContainer;
